module.exports = __webpack_public_path__ + "img/1552941620.4bd16110.jpg";